module.exports = __webpack_public_path__ + "assets/img/car23.b793ff77.jpg";